export const LEAD_DEAL_RESULT = {
  VENDOR_ONLY: 1, /** Сделка прошла только по переданному вендору **/
  VENDOR_WITH_UPSELL: 2, /** Сделка прошла только по переданному вендору, но удалось сделать доппродажу **/
  DIFFERENT_VENDOR: 3, /** Сделка прошла по другому вендору **/
}


// WEBPACK FOOTER //
// ./src/modules/leads/domain/data/deal.result.data.js